import React from 'react';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../CommonComponents/OPL/Icon/Icon';
import { IconButton } from '../../CommonComponents/OPL/IconButton/IconButton';
import {
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
} from '../../CommonComponents/OPL/Popover/Popover';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { Tooltip } from '../../CommonComponents/OPL/Tooltip/Tooltip';

interface Props {
  warnings: string[];
  errors: string[];
  fileName: string;
}

export const WarningsPopover = ({ warnings, errors, fileName }: Props) => {
  const totalCount = warnings.length + errors.length;

  return (
    <Popover>
      <Tooltip content="View warnings" placement="top">
        <PopoverTrigger>
          <IconButton
            variant="warning"
            size="small"
            aria-label={`${totalCount} issue${totalCount !== 1 ? 's' : ''} for ${fileName}`}
            icon="far fa-exclamation-triangle"
            data-testid="PlanImportWarning"
          />
        </PopoverTrigger>
      </Tooltip>

      <PopoverContent width={360} maxHeight={320} p="16" css={{ overflowY: 'auto' }}>
        <PopoverArrow />

        <Text fontWeight={600} fontSize="small" mb="12">
          Warnings &amp; Errors
        </Text>

        {errors.length > 0 && (
          <Box mb={warnings.length > 0 ? '12' : '0'}>
            {errors.map((error, i) => (
              <Box
                key={`e-${i}`}
                display="flex"
                mb="8"
                css={({ theme }) => ({ gap: theme.space[8] })}
              >
                <Text color="danger.500" fontSize="small">
                  <Icon className="fas fa-times-circle" />
                </Text>

                <Text fontSize="small" color="danger.600">
                  {error}
                </Text>
              </Box>
            ))}
          </Box>
        )}

        {warnings.map((warning, i) => (
          <Box key={`w-${i}`} display="flex" mb="8" css={{ gap: 8 }}>
            <Icon className="fas fa-exclamation-triangle" color="warning.500" fontSize="small" />

            <Text fontSize="small">{warning}</Text>
          </Box>
        ))}
      </PopoverContent>
    </Popover>
  );
};
